<template>
<div class="create-message-wrapper" slot="content" :class="{ 'noMargin': moduleType === 'bot-builder' }">
  <div v-if="templatesLoading || (!allWhatsappTemplateData.length && moduleType === 'liveChat')" class="loading-wrapper">
    <VProgressRing />
    <span>Loading Whatsapp templates...</span>
  </div>
  <div v-if="allWhatsappTemplateData.length > 0" :class="{custBorder: selectedTemplate?.id || loading}">
    <selectDropDown :options="templatesListDropDown" :isDisabled="isViewMode" placeholder="Search whatsapp templates" :clientSideSearch="true" @onSelectOption="onChangeTemplateHandler" :selectedValueProp="waTemplateId || editBroadcast.wa_templateid" />
  </div>
  <div v-if="allLanguages.length = 0" class="optionsContainer">
    <p class="sub-title">Select language </p>
    <VSelect :disabled="!waTemplateId" v-model="waLanguage" aria-label="language" placeholder="select Language" appearance="ghost" class="vivid-select">
      <VOption :value="undefined" text="Select Language"></VOption>
      <VOption v-for="thisLang in allLanguages" :key="thisLang.id" :value="thisLang.id" :text="thisLang.name"></VOption>
    </VSelect>
  </div>
  <div class="ion-no-padding">
    <div class="rendering-section" :class="{loading: loading && waTemplateId}">
      <div v-if="loading && waTemplateId" class="loading-wrapper">
        <VProgressRing />
        <span>Please wait...</span>
      </div>
       <!-- Image -->
      <div v-if="header?.format == 'IMAGE'">
        <upload-files-v-2 uploadURLEnabled allowDynamicURL
          allowedImageTypes="image/png, image/jpeg, image/jpg"
          :isViewOnlyMode="isViewMode"
          :media_url="media_url"
          :uploaded_url_type="uploaded_url_type"
          :disableDynamicURL="disableDynamicURL"
          @url-uploaded="(uploadedUrlData) => handleUrlUpload(uploadedUrlData.file_url)"
          :meta="{is_export: false, is_broadcast: false, is_redact: false, is_public: true, conversation_id: undefined, channel: 'whatsapp'}"
          type="image" :multiple="false" id="'uploadHeaderImage'" ref="uploadHeaderImage" :maxFileSizeAllowed="5" v-model:loading="filesUploading" @send-upload-data="handleFilesUpload" @url-type-changed="(value) => { isStaticorDynamic = value; }">
          <p class="sub-title">Image </p>
          <div class="flexContainer">
            <div class="info-box">
              <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
              <p class="sub-title ion-no-margin">Max file size 5MB (.jpeg, .jpg, .png only)</p>  
            </div>  
            <div class="flexBox">
              <button :disabled="filesUploading || isViewMode" class="btn-outline-secondary">
                <VIcon v-if="!filesUploading" :name="icons.imageOutline" class="icon"></VIcon>
                <VProgressRing v-if="filesUploading" :size="-5" />
                <span v-else>Upload Image</span>
              </button>
            </div>
          </div>
        </upload-files-v-2>
      </div>
      <!-- Video -->
      <div v-else-if="header?.format == 'VIDEO'">
      <upload-files-v-2 uploadURLEnabled allowDynamicURL
        allowedVideoTypes="video/mp4"
        :isViewOnlyMode="isViewMode"
        :media_url="media_url"
        :uploaded_url_type="uploaded_url_type"
        :disableDynamicURL="disableDynamicURL"
        @url-uploaded="(uploadedUrlData) => handleUrlUpload(uploadedUrlData.file_url)"
        :meta="{is_export: false, is_broadcast: false, is_redact: false, is_public: true, conversation_id: undefined, channel: 'whatsapp'}"
        type="video" :multiple="false" id="'headerVideo'" ref="headerVideo" :maxFileSizeAllowed="16" v-model:loading="filesUploading" @send-upload-data="handleFilesUpload" @url-type-changed="(value) => { isStaticorDynamic = value; }">
        <p class="sub-title">Video</p>
        <div class="flexContainer">
          <div class="info-box">
            <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
            <p class="sub-title ion-no-margin">Max file size 16MB (.mp4 only)</p>  
          </div>  
          <div class="flexBox">
            <button :disabled="filesUploading || isViewMode" class="btn-outline-secondary">
              <VIcon v-if="!filesUploading" :name="icons.videocamOutline" class="icon"></VIcon>
              <VProgressRing v-if="filesUploading" :size="-5" />
              <span v-else>Upload Video</span>
            </button>
          </div>
        </div>
      </upload-files-v-2>
      </div>
      <!-- Document -->
      <div v-else-if="header?.format == 'DOCUMENT'">
      <upload-files-v-2 uploadURLEnabled allowDynamicURL
        allowedDocumentTypes="application/pdf"
        :isViewOnlyMode="isViewMode"
        :media_url="media_url"
        :uploaded_url_type="uploaded_url_type"
        :disableDynamicURL="disableDynamicURL"
        @url-uploaded="(uploadedUrlData) => handleUrlUpload(uploadedUrlData.file_url)"
        :meta="{is_export: false, is_broadcast: false, is_redact: false, is_public: true, conversation_id: undefined, channel: 'whatsapp'}"
      type="document" :multiple="false" id="'headerDocument'" ref="headerDocument" :maxFileSizeAllowed="100" v-model:loading="filesUploading" @send-upload-data="handleFilesUpload" @url-type-changed="(value) => { isStaticorDynamic = value; }">
      <p class="sub-title">Document</p>
      <div class="flexContainer">
        <div class="info-box">
          <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
          <p class="sub-title ion-no-margin">Max file size 100MB (.pdf only)</p>  
        </div>  
        <div class="flexBox">
          <button :disabled="filesUploading || isViewMode" class="btn-outline-secondary">
            <VIcon v-if="!filesUploading" :name="icons.documentOutline" class="icon"></VIcon>
            <VProgressRing v-if="filesUploading" :size="-5" />
            <span v-else>Upload Document</span>
          </button>
        </div>
      </div>
      </upload-files-v-2>
      </div>
      <div v-if="isFileUploaded && isStaticorDynamic == 'static'">
        <div class="uploadedContainer">
          <div class="fileName">          
            <div class="uploadedIcon">
              <VIcon :name="getIcon(header.format)" class="defaultColor"></VIcon>
            </div>
            <p class="title ion-no-margin" v-if="isImageOrVideo">{{ uploadedFileName}}</p>
            <a :href="header.url" v-else-if="isDocument" target="_blank" rel="noreferer noopener" title="View uploaded file" class="documentURL"> {{ uploadedFileName }} </a>
          </div>
          <button @click="resetUploadedFiles" :disabled="isViewMode" class="icon-btn">
            <VIcon name="delete-line" class="trashIcon"></VIcon>
          </button>
        </div>
      </div>
      <div v-if="headerText || textToRender || footerText" class="text-message-wrapper">
        <div v-if="headerText" class="header">
          <b v-html="headerText"></b>
        </div>
        <div v-if="textToRender">
          <div class="content">
            <p v-html="textToRender"></p>
          </div>
        </div>
        <div v-if="footerText" class="footer">
          <p v-html="footerText"></p>
        </div>
        <div class="action-btn-wrapper">
          <button v-for="(button, index) in allButtons" :key="index" class="btn-action-round" :disabled="isViewMode" @click="buttonClickHandler(button)" >{{ button.text }}</button>
        </div>
      </div>
  </div>
  <!-- Displaying Carousel template start -->
  <div v-if="wa_template_subtype == 'Carousel'" class="singleCarouselCard">
    <div v-for="(carousel, index) in carousel_message_json?.CAROUSEL.cards" :key="index" class="container">
      <div class="img-block cursorPointer" @click="!isViewMode ? openCarouselHeaderEditModal(index) : null" :class="{ 'disabledContainer': isViewMode }">
        <div v-if="carousel?.components[0].overridden_url">
          <div v-if="carousel?.components[0].overridden_url_type === 'dynamic'" class="dynamic-carousel-placeholder">
            <VIcon :name="carousel?.components[0].format === 'IMAGE' ? icons.imageOutline : icons.videocamOutline" class="dynamic-placeholder-icon"></VIcon>
            <p class="dynamic-url-label">Dynamic {{ carousel?.components[0].format === 'IMAGE' ? 'Image' : 'Video' }}</p>
          </div>
          <template v-else>
            <img v-if="carousel?.components[0].format == 'IMAGE'" :src="sanitizeHardLinkUrl(carousel?.components[0].overridden_url)" width="200" class="carouselImage" alt="overridden media" />
            <video v-else :src="sanitizeHardLinkUrl(carousel?.components[0].overridden_url)" controls preload="metadata" width="200" class="carouselImage" />
          </template>
        </div>
        <div v-else-if="carousel?.components[0].image_url !== ''">
          <div v-if="carousel?.components[0].format == 'IMAGE'">
            <img :src="sanitizeHardLinkUrl(carousel?.components[0].image_url)" width="200" class="carouselImage" />    
          </div>
          <div v-else>
            <video :src="sanitizeHardLinkUrl(carousel?.components[0].image_url)" controls preload="metadata" width="200" class="carouselImage" />           
          </div>
        </div>
        <div v-else class="text-center">
          <VIcon :name="icons.imageOutline"></VIcon>
          <p class="sub-title ion-no-margin">Click to add media</p>
        </div>
      </div>
      <div class="carousel-title">
        <p class="ion-no-margin title">{{ carousel.components[1].text }}</p>
      </div>
      <div v-for="(button, index) in carousel.components[2].buttons" :key="index" lines="none" @click="(button.sub_type === 'url' || button.type === 'URL') && !isViewMode ? carouselButtonClickHandler(button, carousel, index) : null" class="bttnContainer cursorPointer" :class="{ 'singleButtonPadding': carousel.components[2].buttons.length === 1, 'disabledContainer': isViewMode, 'clickableButton': (button.sub_type === 'url' || button.type === 'URL') && !isViewMode }">
        <div class="button-text-container">
          <VIcon v-if="button.action !== undefined || button.type !== undefined || button.sub_type !== undefined" :name="getCarouselIcon(button)" class="carouselButtonIcon"></VIcon>
          <span class="bttnTitle ion-no-margin">{{ button.text }}</span>
        </div>
      </div>
    </div>
  </div>
  <!-- Displaying Carousel template end -->

    <div class="custom-variable-input-wrapper" v-if="customInputs.length">
      <div v-for="(input, index) in customInputs" :key="index" >
        <div class="flex-start paddingBottom flexText">
          <p class="sub-title ion-no-margin">Enter custom message for <b style="color: var(--black)">{{ input.label }} </b></p>
          <HelpTooltip v-if="moduleType == 'bot-builder'" floating>
            {{ `You can add up to 1000 characters of static text to each custom field (e.g., "Singapore" for <custom_field_place>). To personalize using CRM (e.g., custom data labeled "place"), enter @crmfield as the value in the respective field.`}} 
          </HelpTooltip>
          <HelpTooltip v-else floating>
            {{ `By default, this field uses the existing value from the Custom Field. You may change it if needed. If the Custom Field does not exist, please enter a value manually.`}} 
          </HelpTooltip>
        </div>
        <div class="counter-wrapper">
          <VTextField :clear-input="true" :id="input.id" v-model="input.value" :readonly="isViewMode" :maxlength="1000" aria-label="Button title" placeholder="Enter Text" appearance="ghost" class="vivid-input"></VTextField>
          <div class="custom-counter">
              {{ (input.value || '').length }}/1000
          </div>
        </div>
      </div>
    </div>
  </div>

  <VDialog v-if="openModal" :open="openModal" :headline="modalTitle" modal @close="closeButtonConfModal" :style="{ '--dialog-min-inline-size': '500px', '--dialog-max-inline-size': '600px' }">
    <template #body>
      <DynamicUrlButtonConf v-if="openDynamicUrlModal" :clickedButton="clickedButton" :key="dynamicModalKey" ref="DynamicUrlButtonConf" />
      <StaticButtonConf v-if="openStaticButtonModal" :clickedButton="clickedButton" :key="dynamicModalKey" ref="StaticButtonConf"></StaticButtonConf>
    </template>
    <template #action-items>
      <VButton connotation="cta" appearance="filled" label="Save" @click="updateButtonConfiguration"></VButton>
    </template>
  </VDialog>

  <CarouselHeaderMediaModal
    :isOpen="openCarouselHeaderModal"
    :cardIndex="carouselHeaderEditIndex"
    :cardData="carouselHeaderEditIndex >= 0 ? carousel_message_json?.CAROUSEL?.cards[carouselHeaderEditIndex] : null"
    @close="closeCarouselHeaderModal"
    @media-updated="onCarouselHeaderMediaUpdated"
    @media-removed="onCarouselHeaderMediaRemoved"
  />

</div>
</template>

<script>
import { localeFullFormData_whatsapp } from '/src/resources/js/all-locale-data';
// Ionic imports removed - migrated to Vivid

const close = 'close-line';
const documentOutline = 'clear-file-line';
const imageOutline = 'image-line';
const videocamOutline = 'video-line';
const informationCircleOutline = 'info-line';
const callOutline = 'call-line';
const openOutline = 'open-line';
const copyOutline = 'copy-2-line';
const arrowUndoOutline = 'undo-solid';
import DynamicUrlButtonConf from "./dynamic-url-button-conf.vue";
import StaticButtonConf from "./static-button-conf.vue";
import CarouselHeaderMediaModal from "./carousel-header-media-modal.vue";
import { sanitizeHardLinkUrl } from '@/helpers/message.helpers';
import selectDropDown from '/src/components/selectDropDown.vue';
import { parseTargetingConditions } from '@/helpers/segments.helpers';
import uploadFilesV2 from "@/components/uploadFilesV2.vue";
import apiInterceptor from '@/shared/apiInterceptor';
import HelpTooltip from "/src/components/HelpTooltip.vue";
import { useUIStore } from '@/stores/ui';
import { useAuthStore } from '@/stores/auth';
import { useSocialChannels } from '@/composables/useSocialChannels';
import { environment } from '@/shared/env.js';
import moment from 'moment-timezone';


export default {
  mixins: [],
  components: { DynamicUrlButtonConf, StaticButtonConf, CarouselHeaderMediaModal, uploadFilesV2, selectDropDown, HelpTooltip },
  setup() {
    const { whatsAppSocialData } = useSocialChannels();
    return { whatsAppSocialData };
  },
  data() {
    return {
      loading: false,
      templatesLoading: false,
      waLanguage: "",
      waTemplateId: "",
      icons: { documentOutline, close, imageOutline, videocamOutline, informationCircleOutline },
      textToRender: "",
      headerText: "",
      footerText: "",
      header: {},
      customInputs: [],
      openModal: false,
      openDynamicUrlModal: false,
      openStaticButtonModal: false,
      clickedButton: "",
      modalTitle: "",
      selectedTemplate: {},
      allButtons: [],
      filesUploading: false,
      uploadedFileName: '',
      isFileUploaded: false,
      simpleMessageTags: [],
      wa_template_subtype: '',
      carousel_message_json: [],
      quick_replies: [],
      selectedTemplateId: '',
      dynamicModalKey: 0,
      isSelectedFromDropDown: false,
      isStaticorDynamic: 'static',
      media_url: '',
      uploaded_url_type: 'static',
      // Carousel button editing properties
      clickedCarouselButton: null,
      currentCarouselCard: null,
      currentCarouselButtonIndex: -1,
      // Carousel header media override modal properties
      openCarouselHeaderModal: false,
      carouselHeaderEditIndex: -1
    }
  },
  props: {
    editBroadcast: {
      type: Object,
      default: () => { return {}; }
    },
    moduleType: {
      type: String,
      default: "broadcast",
    },
    selectedTemplateName: {
      type: String,
      default: "",
    },
    isViewMode: {
      type: Boolean,
      default: false
    },
    versionManager: {
      type: String,
      default: "whatsAppCreateMessage_A",
    },
    isDuplicateBroadcast: {
      type: Boolean,
      default: false
    },
    allWhatsappTemplateData: {
      type: Array,
      default: () => { return []; }
    },
    disableDynamicURL: {
      type: Boolean,
      default: false
    },
    url_type: {
       type: String,
      default: "static",
    },
    conversationid: {
      type: String,
      default: ""
    }
  },
  async mounted() {
    if(this.editBroadcast?.id) { // EDIT BROADCAST CASE: preload values for selected wa template
      this.preLoadValues();
    } else if (this.editBroadcast?.page_id?.trim()) { // DUPLICATE BROADCAST CASE: preload values for selected wa template
      this.preLoadValues();
    }
    
    // Check for initial auto-selection of "none" for compliance keywords
    if (this.moduleType === 'compliance_keywords' && this.editBroadcast && this.isEmptyTemplate(this.editBroadcast)) {
      console.log('WhatsApp mounted: Initial auto-select NONE due to empty template_data:', this.editBroadcast.template_data);
      this.$nextTick(() => {
        this.waTemplateId = 'none';
        this.onChangeTemplateHandler({selectedValue: 'none'});
      });
    }
  },
  emits: ['onUpdatePreview', 'alltemplateValues', 'fileUploading', 'templatesLoading', 'updatedMedia', 'resetValues', 'final-url-type', 'carouselMessageUpdated'],
  computed: {
    user() { return useAuthStore().cleanUserData; },
    allLanguages() {
      let allLanguageCodes = [];
      this.allWhatsappTemplateData.forEach((template) => {
        if (template.language && this.waTemplateId === template.id) {
          allLanguageCodes.push(template.language);
        }
      });
      return localeFullFormData_whatsapp.filter((e) => allLanguageCodes.indexOf(e.id) > -1);
    },
    noValuesEnteredForButtons() {
      let missedValue = false;
      this.allButtons.forEach((button) => {
        if (button.static != true) {
          if (button.sub_type == 'url' && button.parameters && !button.parameters[0]?.text) {
            missedValue = 'url';
          } else if (button.sub_type == 'copy_code' && button.parameters && !button.parameters[0]?.coupon_code) {
            missedValue = 'couponCode';
          }
        }
      });
      return missedValue;
    },
    noValuesEnteredForCarouselButtons() {
      let missedValue = false;
      if (this.wa_template_subtype === 'Carousel' && this.carousel_message_json?.CAROUSEL?.cards) {
        this.carousel_message_json.CAROUSEL.cards.forEach((card) => {
          const buttonComponent = card.components?.find(comp => comp.type === 'BUTTONS');
          if (buttonComponent?.buttons) {
            buttonComponent.buttons.forEach((button) => {
              if (button.type === 'URL' && button.example && button.example.length > 0) {
                // This button has dynamic URL parameters
                if (!button.parameters || !button.parameters[0]?.text) {
                  missedValue = 'url';
                }
              }
            });
          }
        });
      }
      return missedValue;
    },
    noValuesEnteredForCustomVariables() {
      let missedValue = false;
      this.customInputs.forEach((input) => {
        if (!input.value) {
            missedValue = true;
        }
      });
      return missedValue;
    },
    previewBody() {
      let html = this.textToRender;
      if (this.customInputs?.length) {
        this.customInputs.forEach((input, index) => {
          let pIndex = index + 1;
          if (input.value) {
            html = html.replace(`<span class="dynamic-variable-span">{custom_field_var${pIndex}}</span>`, input.value);
          }
        })
      }
      let formattedHeader = {};
      
      // First, try to use this.header (current component state) which is most up-to-date
      if (this.header && Object.keys(this.header).length > 0) {
        formattedHeader = { ...this.header };
      }
      // Fallback to editBroadcast data for view mode or existing broadcasts
      else if ((this.isViewMode || (this.editBroadcast?.id)) && this.editBroadcast.wa_message_params?.HEADER?.[0]) {
        const headerRaw = this.editBroadcast.wa_message_params.HEADER[0];
        if (typeof headerRaw === 'object' && headerRaw !== null) {
          const mediaUrl = Object.keys(headerRaw)[0];
          const mediaType = headerRaw[mediaUrl];

          formattedHeader = {
            format: mediaType.toUpperCase(), // e.g. 'IMAGE', 'VIDEO', 'DOCUMENT'
            url: mediaUrl
          };
        }
      }
      // Final fallback to template header
      else if (this.selectedTemplate?.message?.HEADER && typeof this.selectedTemplate.message.HEADER === 'object' && this.selectedTemplate.message.HEADER !== null) {
        formattedHeader = { ...this.selectedTemplate.message.HEADER };
      }
      const buttons = (this.isViewMode || (this.editBroadcast?.id))
        ? this.editBroadcast.wa_message_params?.BUTTONS
        : this.allButtons;

      let couponCode = '';

      if (buttons?.length) {
        if (this.isViewMode) {
          const viewOnlyButton = buttons.find(btn => btn.sub_type?.toLowerCase() === 'copy_code');
          couponCode = viewOnlyButton?.parameters?.[0]?.coupon_code || '';
        } else {
          const editModeButton = buttons.find(btn => btn.type?.toLowerCase() === 'copy_code');
          if (editModeButton) {
            couponCode = editModeButton.payload || '';
          } else {
            const fallbackViewButton = buttons.find(btn => btn.sub_type?.toLowerCase() === 'copy_code');
            couponCode = fallbackViewButton?.parameters?.[0]?.coupon_code || '';
          }
        }
      }
      let objBody = {
        header: formattedHeader,
        body: {
          html: html,
        },
        footer: this.footerText,
        allButtons: this.allButtons,
        coupon_code: couponCode
      };
      return objBody;
    },
    templatesListDropDown() {
      this.allWhatsappTemplateData.map( (template) => {
        if( template && template?.id ) {
          template.value = template?.template_id;
        }
        template.title = template.template_name;
        return template;
      } )
      return this.allWhatsappTemplateData;
    },
    isImageOrVideo() {
      return this.header.format === 'IMAGE' || this.header.format === 'VIDEO';
    },
    isDocument() {
      return this.header.format === 'DOCUMENT';
    }
  },
  watch: {
    previewBody: {
      handler() {
        this.$emit('onUpdatePreview', this.previewBody);
      },
      deep: true
    },
    filesUploading: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('fileUploading', this.filesUploading);
        }
      },
    },
    isStaticorDynamic(newVal) {
      // Check if we should preserve header data (duplicate/edit mode with existing header)
      const shouldPreserveHeader = (this.isDuplicateBroadcast || this.editBroadcast?.id) && 
                                   this.editBroadcast?.wa_message_params?.HEADER && 
                                   Array.isArray(this.editBroadcast.wa_message_params.HEADER) && 
                                   this.editBroadcast.wa_message_params.HEADER.length > 0;
      
      // Only reset if not preserving header, or if switching to dynamic mode
      if (!shouldPreserveHeader || newVal === 'dynamic') {
        this.resetUploadedFiles();
      }
      
      this.$emit('final-url-type', newVal);
    },
    templatesLoading: 'emitCombinedTemplatesLoading',
    loading: 'emitCombinedTemplatesLoading',
    waTemplateId: 'emitCombinedTemplatesLoading',
    editBroadcast: {
      handler(newVal) {
        // Auto-select "none" if we receive empty template data for compliance keywords
        if (this.moduleType === 'compliance_keywords' && newVal && this.isEmptyTemplate(newVal) && this.allWhatsappTemplateData.length > 0) {
          console.log('WhatsApp: Auto-selecting NONE due to empty template_data:', newVal.template_data);
          this.$nextTick(() => {
            this.onChangeTemplateHandler({selectedValue: 'none'});
          });
        }
      },
      immediate: true,
      deep: true
    },
    allWhatsappTemplateData: {
      handler(newVal) {
        // When templates are loaded, check if we need to auto-select "none"
        if (this.moduleType === 'compliance_keywords' && newVal && newVal.length > 0 && this.editBroadcast && this.isEmptyTemplate(this.editBroadcast)) {
          this.$nextTick(() => {
            this.onChangeTemplateHandler({selectedValue: 'none'});
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    moment,
    sanitizeHardLinkUrl,
    async preLoadValues() {
      this.waTemplateId = this.editBroadcast.wa_templategid || this.editBroadcast.wa_templateid;
      this.waLanguage = this.editBroadcast.wa_language;
      this.uploaded_url_type = this.url_type || 'static';
      this.media_url = Object.keys(this.editBroadcast.wa_message_params?.HEADER?.[0] || {})[0];
      if(this.media_url?.length) {
        this.uploadedFileName = this.media_url;
        this.isFileUploaded = true;
        this.isStaticorDynamic = this.uploaded_url_type;
      } 
      // Only set header if HEADER exists in wa_message_params
      if (this.editBroadcast?.wa_message_params?.HEADER && Array.isArray(this.editBroadcast.wa_message_params.HEADER) && this.editBroadcast.wa_message_params.HEADER.length > 0) {
        // Convert HEADER array format back to header object format
        const headerRaw = this.editBroadcast.wa_message_params.HEADER[0];
        if (typeof headerRaw === 'object' && headerRaw !== null) {
          const mediaUrl = Object.keys(headerRaw)[0];
          const mediaType = headerRaw[mediaUrl];
          this.header = {
            format: mediaType.toUpperCase(),
            url: mediaUrl
          };
        }
      }
      if(this.editBroadcast.channel == 'whatsapp') {
        // For compliance-keywords module, add extra validation to prevent unnecessary API calls
        if (this.moduleType === 'compliance-keywords') {
          if (this.editBroadcast.wa_templategid || this.editBroadcast.wa_templateid) {
            await this.fetchTemplate();
          }
        } else {
          // For other modules (broadcast, bot-builder, liveChat), keep original behavior
          await this.fetchTemplate();
        }
      }
      // Only call onLoadPrepareSelectedTemplate if not in edit mode
      if (!this.editBroadcast?.id || this.moduleType == 'bot-builder') {
        this.onLoadPrepareSelectedTemplate();
      }
    },
    preLoadButtonsValues() {
      if(this.editBroadcast.wa_message_params?.BUTTONS && this.allButtons?.length){
        this.editBroadcast.wa_message_params.BUTTONS.forEach((button, index) => {
          const allButton = this.allButtons[index];          
          if ( allButton && Array.isArray(allButton.parameters) && allButton.parameters.length && Array.isArray(button.parameters) && button.parameters.length && allButton.sub_type === button.sub_type ) {
            if (allButton.sub_type === 'copy_code') {
              // Handle copy_code specific parameters
              allButton.parameters[0].coupon_code = button.parameters[0].coupon_code || '';
              allButton.parameters[0].coupon_type = button.parameters[0].coupon_type || 'static';
            } else {
              // Handle other button types (URL buttons)
              allButton.parameters[0].text = button.parameters[0].text;
            }
          }
        });
      }
      // Load carousel button values if carousel template
      this.preLoadCarouselButtonsValues();
    },
    preLoadCarouselButtonsValues() {
      if (this.wa_template_subtype === 'Carousel' && this.carousel_message_json?.CAROUSEL) {
        // For bot-builder, check CAROUSEL_BUTTONS, otherwise check BUTTONS
        const savedButtonsSource = (this.moduleType === 'bot-builder') 
          ? this.editBroadcast.wa_message_params?.CAROUSEL_BUTTONS 
          : this.editBroadcast.wa_message_params?.BUTTONS;
        
        if (!savedButtonsSource) return;
        
        const savedButtons = savedButtonsSource;
        
        // Create a map of button parameters by card_index and button index within card (for bot-builder) or global index (for others)
        const buttonParamsMap = {};
        savedButtons.forEach((savedButton) => {
          if (savedButton.sub_type === 'url' && savedButton.index !== undefined) {
            let key;
            if (this.moduleType === 'bot-builder' && savedButton.card_index !== undefined) {
              // For bot-builder, use card_index + button index within card
              key = `${savedButton.card_index}_${savedButton.index}`;
            } else {
              // For other modules, use global button index
              key = savedButton.index;
            }
            buttonParamsMap[key] = savedButton.parameters;
          }
        });
        
        // Apply saved parameters to carousel buttons
        let currentButtonIndex = 0;
        this.carousel_message_json.CAROUSEL.cards.forEach((card, cardIndex) => {
          const buttonComponent = card.components?.find(comp => comp.type === 'BUTTONS');
          if (buttonComponent?.buttons) {
            buttonComponent.buttons.forEach((button, buttonIndex) => {
              if (button.type === 'URL') {
                let key;
                if (this.moduleType === 'bot-builder') {
                  // For bot-builder, use card_index + button index within card
                  key = `${cardIndex}_${buttonIndex}`;
                } else {
                  // For other modules, use global button index
                  key = currentButtonIndex;
                }
                
                if (buttonParamsMap[key]) {
                  button.parameters = [...buttonParamsMap[key]];
                }
              }
              currentButtonIndex++;
            });
          }
        });
      }
    },
    preLoadCarouselHeadersValues() {
      if (this.wa_template_subtype === 'Carousel' && this.carousel_message_json?.CAROUSEL?.cards) {
        const savedCarouselHeaders = this.editBroadcast.wa_message_params?.CAROUSEL_HEADERS;
        const savedCarouselUrlTypes = this.editBroadcast.url_types?.CAROUSEL_HEADERS;

        if (!savedCarouselHeaders || !Array.isArray(savedCarouselHeaders)) return;

        let hasOverrides = false;
        savedCarouselHeaders.forEach((headerObj, index) => {
          if (index < this.carousel_message_json.CAROUSEL.cards.length) {
            const card = this.carousel_message_json.CAROUSEL.cards[index];
            const mediaUrl = Object.keys(headerObj)[0];
            const urlType = savedCarouselUrlTypes?.[index] || 'static';

            // Set override if the URL differs from the template default
            if (mediaUrl && mediaUrl !== card.components[0].image_url) {
              Object.assign(card.components[0], {
                overridden_url: mediaUrl,
                overridden_url_type: urlType
              });
              hasOverrides = true;
            }
          }
        });

        // Force reactivity update so template re-renders with overrides
        if (hasOverrides) {
          this.carousel_message_json = JSON.parse(JSON.stringify(this.carousel_message_json));
          this.$emit('carouselMessageUpdated', this.carousel_message_json);
        }
      }
    },
    initializeCarouselButtons() {
      if (this.carousel_message_json?.CAROUSEL?.cards) {
        this.carousel_message_json.CAROUSEL.cards.forEach((card) => {
          const buttonComponent = card.components?.find(comp => comp.type === 'BUTTONS');
          if (buttonComponent?.buttons) {
            buttonComponent.buttons.forEach((button) => {
              // Initialize parameters array for URL buttons that have examples (dynamic parameters)
              if (button.type === 'URL' && button.example && button.example.length > 0) {
                if (!button.parameters) {
                  button.parameters = [{ type: 'text', text: '' }];
                }
                button.sub_type = 'url';
              }
            });
          }
        });
      }
    },
    isEmptyTemplate(editBroadcast) {
      // Check if template data is empty
      const templateData = editBroadcast?.template_data;
      
      // Check for null or undefined template_data
      if (!templateData || templateData === null) return true;
      
      // Check if it's an empty object
      if (typeof templateData === 'object' && Object.keys(templateData).length === 0) {
        return true;
      }
      
      // Check if template_data has empty or minimal content
      if (templateData && typeof templateData === 'object') {
        const hasEmptyId = !templateData.id || templateData.id === '';
        const hasEmptyName = !templateData.name || templateData.name === '';
        const hasEmptyComponents = !templateData.components || 
                                  (Array.isArray(templateData.components) && templateData.components.length === 0);
        
        if (hasEmptyId && hasEmptyName && hasEmptyComponents) {
          return true;
        }
      }
      
      return false;
    },
    async fetchDefaultValuesForCustomFields() {
      try {
        this.loading = true;
        const params = { custom_field_keys: this.customInputs.map(input => input.label) };
        const customValuesResponse = await apiInterceptor.get(environment("VUE_APP_API_URL") + "crm/v1/customers/" + this.conversationid + '/custom-fields', { params });
        console.log(customValuesResponse);
        if(customValuesResponse && customValuesResponse.data) {
          this.customInputs.forEach(input => {
            const defaultValue = customValuesResponse.data.find(item => item.field === input.label)?.value || '';
            if (defaultValue && !input.value) {
              input.value = defaultValue;
            }
          });
        }
      } catch (error) {
        console.error("Error fetching default values for custom fields:", error);
      } finally {
        this.loading = false;
      }
    },
    async generateTextToRender(text) {
      this.textToRender = text;
      // Clear customInputs to prevent duplicates (e.g., during duplicate broadcast)
      this.customInputs = [];
      const thisTemplate = this.selectedTemplate;
      if (thisTemplate.message_params.BODY && thisTemplate.message_params.BODY.length) {
        let varIndex = 0;
        thisTemplate.message_params.BODY.forEach(
          (thisParam, paramIndex) => {
            let param = Object.keys(thisParam)[0];
            let value = Object.values(thisParam)[0];
            let pIndex = paramIndex + 1;
            let strToReplace = "";
            switch (param) {
              case "<username>":
                {
                  strToReplace = "{User's Name}";
                  break;
                }
              case "<userfirstname>":
                {
                  strToReplace = "{User's First Name}";
                  break;
                }
              case "<userlastname>":
                {
                  strToReplace = "{User's Last Name}";
                  break;
                }
              case "<userphone>":
                {
                  strToReplace = "{User's Phone}";
                  break;
                }
              case "<useremail>":
                {
                  strToReplace = "{User's Email}";
                  break;
                }
              case "<shopname>":
                {
                  strToReplace = "{Store Name}";
                  break;
                }
              case "<agentname>":
                {
                  strToReplace = "{Agent Name}";
                  break;
                }
              case "<sellername>":
                {
                  strToReplace = "{Account Owner Name}";
                  break;
                }
              case "<selleremail>":
                {
                  strToReplace = "{Support E-mail}";
                  break;
                }
              case "<sellerphone>":
                {
                  strToReplace = "{Support Phone}";
                  break;
                }
              case "<menuaddress>":
                {
                  strToReplace = "{Outlet Address}";
                  break;
                }
              default: {
                if (param.includes("<custom_field_")) {
                  let customFieldText = param.replace("<custom_field_", "");
                  customFieldText = customFieldText.replace(">", "");
                  strToReplace = "{custom_field_" + customFieldText + "}";
                  const customFieldId = `${pIndex}_${value}`;

                  // persist values for edit broadcast
                  let objMessageValue = null;
                  if(Array.isArray(this.editBroadcast?.custom_messages)) {
                    objMessageValue = this.editBroadcast?.custom_messages?.find((message) => message.key == customFieldText);
                  }
                  const messageValue = objMessageValue?.value || "";

                  this.customInputs.push({ label: `${customFieldText}`, id: `${customFieldText}`, value: messageValue });
                }
              }
            }
            this.textToRender = this.textToRender.replace("{{" + pIndex + "}}", `<span class="dynamic-variable-span">${strToReplace}</span>`);
            this.textToRender = this.textToRender.replaceAll('\n', '<br>');
          }
        );
      }
      if(this.customInputs?.length && this.conversationid) await this.fetchDefaultValuesForCustomFields();
    },
    resetTemplateValues() {
      this.textToRender = "";
      this.headerText = "";
      this.footerText = "";
      this.header = {};
      this.customInputs = [];
      this.allButtons = [];
      this.wa_template_subtype = '';
      this.carousel_message_json = [];
      this.isStaticorDynamic = 'static';
    },
    onChangeTemplateHandler({selectedValue}) {
      this.isSelectedFromDropDown = true;
      this.waTemplateId = selectedValue;
      
      // Handle "none" selection for compliance keywords
      if (selectedValue === 'none' && this.moduleType === 'compliance-keywords') {
        this.resetTemplateValues();
        this.resetUploadedFiles();
        // Clear the selected template to prevent preview showing old header data
        this.selectedTemplate = {};
        
        // Emit the "none" template data to parent
        this.$emit('alltemplateValues', {
          id: 'none',
          template_id: 'none',
          template_name: 'None'
        });
        return; // Don't fetch template details for "none"
      }
      
      this.resetTemplateValues();
      this.fetchTemplate({onChangeTemplate: true});
      this.resetUploadedFiles();
      // Only emit resetValues for new broadcasts, not during edit mode
      if (!this.editBroadcast?.id) {
        this.$emit('resetValues', '');
      }
    },
    onLoadPrepareSelectedTemplate() {
      this.isSelectedFromDropDown = true;
      this.waTemplateId = this.editBroadcast.wa_templategid || this.editBroadcast.wa_templateid;
      if (this.moduleType === 'compliance-keywords') {
        if (this.waTemplateId && this.waTemplateId !== 'none') {
          this.fetchTemplate();
        }
      } else {
        this.fetchTemplate();
      }
    },
    buttonsListHandler(messageButtons) {
      let buttons = [];
      this.quick_replies = [];
      if (messageButtons) {
        messageButtons.forEach((messageButton, index) => {
          if (messageButton.type === 'URL') {
            let button = { ...messageButton, sub_type: 'url', type: 'button', index };
            button.text = messageButton.text || 'Web Url';
            if (messageButton.example) {
              button.parameters = [{ type: 'text', text: '' }];
            }
            buttons.push(button);
          }
          else if (messageButton.type == 'QUICK_REPLY') {
            let button = { ...messageButton, ...{ sub_type: 'quick_reply', type: 'button', index, static: true } };
            button.text = button.text || 'Quick Reply';
            buttons.push(button);
            this.quick_replies.push(button);
          } else if (messageButton.type == 'PHONE_NUMBER') {
            let button = { ...messageButton, ...{ sub_type: 'phone_number', type: 'button', index, static: true } };
            button.text = button.text || 'Phone Number';
            buttons.push(button);
          } else if (messageButton.type == 'COPY_CODE') {
            let button = { ...messageButton, ...{ sub_type: 'copy_code', type: 'button', index, parameters: [{ "type": "coupon_code", "coupon_code": "", "coupon_type": "static" }] } };
            button.text = button.text || 'Copy code';
            button.payload = 'SAMPLE_COPY_CODE';
            buttons.push(button);
          } else {
            buttons.push(messageButton);
          }
        });
      }
      this.allButtons = buttons;
    },
    closeButtonConfModal() {
      setTimeout(() => {
        this.closeModal();
      }, 500);
    },
    closeModal() {
      this.openModal = false;
      this.openDynamicUrlModal = false;
      this.openStaticButtonModal = false;
      this.clickedButton = "";
      this.modalTitle = "";
      this.clickedCarouselButton = null;
      this.currentCarouselCard = null;
      this.currentCarouselButtonIndex = -1;
    },
    buttonClickHandler(button) {
      this.openModal = true;
      this.clickedButton = button;
      this.dynamicModalKey = Date.now();
      if (button.sub_type == 'url' || button.type == 'URL') {
        this.openDynamicUrlModal = true;
        this.openStaticButtonModal = false;
        this.modalTitle = "Web Page URL Configuration";
      } else if (button.sub_type == 'quick_reply') {
        this.openStaticButtonModal = true;
        this.openDynamicUrlModal = false;
        this.modalTitle = "Quick Reply Configuration";
      } else if (button.sub_type == 'phone_number') {
        this.openStaticButtonModal = true;
        this.openDynamicUrlModal = false;
        this.modalTitle = "Phone Number Configuration";
      } else if (button.sub_type == 'copy_code') {
        this.openDynamicUrlModal = true;
        this.openStaticButtonModal = false;
        this.modalTitle = "Coupon Code Configuration";
      }
    },
    carouselButtonClickHandler(button, carouselCard, buttonIndex) {
      this.openModal = true;
      this.clickedCarouselButton = button;
      this.currentCarouselCard = carouselCard;
      this.currentCarouselButtonIndex = buttonIndex;
      this.dynamicModalKey = Date.now();
      
      // Set clickedButton for compatibility with existing modal components
      this.clickedButton = { ...button };
      
      if (button.sub_type == 'url' || button.type == 'URL') {
        this.openDynamicUrlModal = true;
        this.openStaticButtonModal = false;
        this.modalTitle = "Carousel Button URL Configuration";
      }
    },
    updateButtonConfiguration() {
      // Handle carousel button updates
      if (this.clickedCarouselButton && this.currentCarouselCard) {
        if (this.clickedCarouselButton.sub_type == 'url' || this.clickedCarouselButton.type == 'URL') {
          if (this.$refs.DynamicUrlButtonConf.isDynamicUrl) {
            const updateBtn = this.$refs.DynamicUrlButtonConf.updatedButtonObject;
            // Update the carousel button in place
            const buttonToUpdate = this.currentCarouselCard.components[2].buttons[this.currentCarouselButtonIndex];
            Object.assign(buttonToUpdate, {
              ...updateBtn,
              // Preserve carousel-specific properties
              text: buttonToUpdate.text,
              type: buttonToUpdate.type
            });
          }
        }
        // Clear carousel-specific tracking
        this.clickedCarouselButton = null;
        this.currentCarouselCard = null;
        this.currentCarouselButtonIndex = -1;
      } 
      // Handle regular template button updates
      else if (this.clickedButton) {
        if (this.clickedButton.sub_type == 'url') {
          if (this.$refs.DynamicUrlButtonConf.isDynamicUrl) {
            const updateBtn = this.$refs.DynamicUrlButtonConf.updatedButtonObject;
            this.allButtons[updateBtn.index] = { ...updateBtn };
          }
        } else if(this.clickedButton.sub_type == 'copy_code') {
          const updateCouponCodeBtn = this.$refs.DynamicUrlButtonConf.updatedCouponCodeButtonObject;
          if (!updateCouponCodeBtn?.parameters?.[0]?.coupon_code) {
            return useUIStore().updateToast({
              open: true,
              message: "Please enter coupon code and try again!",
              type: "danger"
            });
          }
          this.allButtons[updateCouponCodeBtn.index] = { ...updateCouponCodeBtn };
        }
      }
      this.closeModal();
    },
    async fetchTemplate({onChangeTemplate = false} = {}) {
      if(!this.allWhatsappTemplateData?.length) {
        return;
      }
      var toFetchId = this.waTemplateId; // selected template ID
      // For compliance-keywords module, prevent fetching if no template ID is provided
      if (this.moduleType === 'compliance-keywords' && !toFetchId) {
        return;
      }
      
      // Prevent API call for "none" selection
      if (toFetchId && toFetchId.toString().toLowerCase() === 'none') {
        return;
      }
      
      try {
        this.loading = true;
        const foundTemplate = this.allWhatsappTemplateData.find(e =>
          (e.template_id === toFetchId || e.template_name === toFetchId || e.id == toFetchId)
        );
        
        // If template not found, don't proceed with API call
        if (!foundTemplate && toFetchId !== undefined) {
          console.warn('Template not found in allWhatsappTemplateData:', toFetchId);
          this.loading = false;
          return;
        }
        
        if (toFetchId !== undefined) {
          if(this.editBroadcast?.id && !this.isSelectedFromDropDown) {
            this.selectedTemplateId = toFetchId;
          } else {
            this.selectedTemplateId = foundTemplate?.id || toFetchId;
          }
          
          if (!this.selectedTemplateId || this.selectedTemplateId.toString().toLowerCase() === 'none') {
            this.loading = false;
            return;
          }
          
          let templateId = this.selectedTemplateId;
          let getTemplateResponse = await apiInterceptor.get(environment("VUE_APP_API_URL") + "social/v1/whatsapp/" + this.whatsAppSocialData.id + '/template/' + templateId );

          this.selectedTemplate = getTemplateResponse.data;
          let thisTemplate = getTemplateResponse.data;
          await this.generateTextToRender(thisTemplate.message.BODY.text);
          this.$emit('alltemplateValues', thisTemplate);

          if(onChangeTemplate) {
            this.header = this.selectedTemplate?.message?.HEADER || {};
          }
          else if(this.isDuplicateBroadcast || this.editBroadcast?.id){
            // Check if HEADER exists and has content
            if (this.editBroadcast?.wa_message_params?.HEADER && Array.isArray(this.editBroadcast.wa_message_params.HEADER) && this.editBroadcast.wa_message_params.HEADER.length > 0) {
              this.header.url = this.media_url;
              this.header.format = (Object.values(this.editBroadcast.wa_message_params.HEADER[0] || {})[0] || '').toUpperCase();
            } else {
              // Fallback to template header if broadcast doesn't have header
              this.header = this.selectedTemplate?.message?.HEADER || {};
            }
          } else {
            this.header = this.selectedTemplate?.message?.HEADER || {};
          }

          if (this.selectedTemplate?.message?.FOOTER?.text) {
            this.footerText = this.selectedTemplate?.message?.FOOTER?.text;
          }

          if (this.selectedTemplate?.message?.HEADER?.text && this.selectedTemplate?.message?.HEADER?.format == "TEXT") {
            this.headerText = this.selectedTemplate?.message?.HEADER?.text;
          }

          if (this.selectedTemplate.message.BUTTONS) {
            this.buttonsListHandler(this.selectedTemplate.message.BUTTONS);
            // Load saved button values after buttons are created - for edit mode
            if (this.editBroadcast?.id && !onChangeTemplate) {
              this.preLoadButtonsValues();
            }
          }
          this.wa_template_subtype = thisTemplate.template_subtype;
          if(this.wa_template_subtype == 'Carousel'){
            this.carousel_message_json = thisTemplate.message;
            // Initialize carousel buttons for editing
            this.initializeCarouselButtons();
            // Load saved carousel button values after carousel is set up - for edit mode
            if (this.editBroadcast?.id && !onChangeTemplate) {
              this.preLoadCarouselButtonsValues();
              this.preLoadCarouselHeadersValues();
            }
          }
        }
      } catch (error) {
        console.error("Exception", error);
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong", type: "danger", });
      } finally {
        this.loading = false;
      }
    },
    isValidToSubmit() {
      // For compliance keywords, "none" is a valid selection
      if (this.moduleType === 'compliance-keywords' && (this.waTemplateId === 'none' || this.selectedTemplate?.id === 'none')) {
        return true;
      }
      
      if (!this.selectedTemplate.id || !this.waTemplateId) {
        useUIStore().updateToast({ open: true, message: "Please select a whatsapp Template", type: "danger", });
        return false;
      }
      else if (
        (this.header.format === 'IMAGE' || this.header.format === 'VIDEO' || this.header.format === 'DOCUMENT') &&
        (
          (!this.isDuplicateBroadcast && !this.header?.url) ||  // when not duplicate, url is required
          (this.isDuplicateBroadcast && (!this.header?.url && (!this.header?.example || this.header.example === '')))  // when duplicate, url or example is required
        ) &&
        (this.uploaded_url_type == 'static' || this.isStaticorDynamic == 'static' )
      ) {
        useUIStore().updateToast({
          open: true,
          message: "Please select a valid header " + this.header.format.toLowerCase() + " to broadcast!",
          type: "danger",
        });
        return false;
      }
      else if (!this.waLanguage && this.allLanguages?.length) {
        useUIStore().updateToast({ open: true, message: "Please select the whatsapp Template Language", type: "danger", });
        return false;
      }
      else if (this.noValuesEnteredForButtons == 'url') {
        useUIStore().updateToast({ open: true, message: "Please click on the button and enter dynamic value.", type: "danger", });
        return false;
      }
      else if (this.noValuesEnteredForButtons == 'couponCode') {
        useUIStore().updateToast({ open: true, message: "Please click on the button and enter the coupon code!", type: "danger", });
        return false;
      }
      else if (this.noValuesEnteredForCarouselButtons == 'url') {
        useUIStore().updateToast({ open: true, message: "Please click on the carousel button and enter dynamic value.", type: "danger", });
        return false;
      }
      else if (this.noValuesEnteredForCustomVariables) {
        useUIStore().updateToast({ open: true, message: "Please fill all the custom messages fields.", type: "danger", });
        return false;
      }
      return true;
    },
    getBroadcastMessageParamsToSave() {
      // For "none" selection, return empty data
      if (this.waTemplateId === 'none' || this.selectedTemplate?.id === 'none') {
        return {
          waTemplateId: null,
          message_params: {},
          custom_messages: {}
        };
      }
      
      let message_params = null, custom_messages = null;
      let messageParams = this.selectedTemplate?.message_params || {};

      // construct header params
      if(!this.isHeadersEmpty(this.header) && this.header.format !== 'TEXT' ) {
        messageParams.HEADER = this.getEditedHeaderParams();
        if(this.isDocument) messageParams.filename = this.uploadedFileName || "File Document";
      }
      // construct button params
      if (this.allButtons?.length) {
        let buttons = [];
        let buttonsWithoutParameters = [];
        this.allButtons.forEach((button) => {
          if (button.static != true && button.parameters) {
            buttons.push(
              {
                "type": "button",
                "sub_type": button.sub_type,
                "index": button.index,
                "parameters": button.parameters
              }
            )
          }
          if ((button.static != true && !button.parameters && button.sub_type == 'url') || (button.static == true && !button.parameters && button.sub_type == 'phone_number')) {
            buttonsWithoutParameters.push(
              {
                "type": "button",
                "sub_type": button.sub_type,
                "index": button.index,
                "parameters": button.url
              }
            )
          }
        });
        var totalButtonsLength = buttons.length + buttonsWithoutParameters.length;
        let quickReplyButtons = this.getEditedButtonParams(totalButtonsLength);
        if (this.moduleType === 'liveChat' || this.moduleType === 'bot-builder' || this.moduleType === 'compliance-keywords') { // Adding All Buttons to payload irrespewctive of static or dynamic type for livechat message templates
          messageParams.BUTTONS = [...buttons, ...quickReplyButtons];
        } else if (buttons.length || (quickReplyButtons.length && (this.moduleType == 'liveChat' || this.moduleType == 'bot-builder' || this.moduleType === 'compliance-keywords'))) {
          messageParams.BUTTONS = [...buttons ];
        }
      }
      
      // Add carousel button parameters for carousel templates
      if (this.wa_template_subtype === 'Carousel' && this.carousel_message_json) {
        let carouselButtons = [];
        let carouselButtonsWithoutParameters = [];
        
        let globalButtonIndex = 0;
        
        if (this.carousel_message_json?.CAROUSEL?.cards) {
          this.carousel_message_json.CAROUSEL.cards.forEach((card, cardIndex) => {
            const buttonComponent = card.components?.find(comp => comp.type === 'BUTTONS');
            if (buttonComponent?.buttons) {
              // For liveChat and bot-builder: reset button index for each card
              // For other modules: use global button index
              let cardButtonIndex = 0;
              
              buttonComponent.buttons.forEach((button, btnIdx) => {
                const buttonIndex = (this.moduleType === 'liveChat' || this.moduleType === 'bot-builder') 
                  ? cardButtonIndex 
                  : globalButtonIndex;
                
                // 1. Buttons with parameters (dynamic buttons)
                if (button.parameters && button.parameters.length > 0 && 
                    ((button.type === 'URL' && button.parameters[0]?.text))) {
                  const dynamicButtonObj = {
                    "type": "button",
                    "sub_type": button.type === 'URL' ? 'url' : button.type.toLowerCase(),
                    "index": buttonIndex,
                    "parameters": button.parameters
                  };
                  
                  // Only add card_index for liveChat and bot-builder
                  if (this.moduleType === 'liveChat' || this.moduleType === 'bot-builder') {
                    dynamicButtonObj.card_index = cardIndex;
                  }
                  
                  carouselButtons.push(dynamicButtonObj);
                }
                // 2. Buttons without parameters (static buttons)
                else if ((button.type == 'URL' && (!button.parameters || !button.parameters[0]?.text)) ||
                         (button.type == 'QUICK_REPLY')) {
                  const staticButtonObj = {
                    "type": "button",
                    "sub_type": button.type.toLowerCase(),
                    "index": buttonIndex,
                    "parameters": button.payload || button.url || button.example?.[0] || ""
                  };
                  
                  // Only add card_index for liveChat and bot-builder
                  if (this.moduleType === 'liveChat' || this.moduleType === 'bot-builder') {
                    staticButtonObj.card_index = cardIndex;
                  }
                  
                  carouselButtonsWithoutParameters.push(staticButtonObj);
                }
                
                cardButtonIndex++;
                globalButtonIndex++;
              });
            }
          });
        }
        
        if (this.moduleType === 'liveChat' || this.moduleType === 'bot-builder') {
          // For liveChat and bot-builder, use CAROUSEL_BUTTONS and only include dynamic buttons
          if (carouselButtons.length > 0) {
            messageParams.CAROUSEL_BUTTONS = carouselButtons;
          }
        } else {
          // For other modules, use BUTTONS and add dynamic buttons
          var totalCarouselButtonsLength = carouselButtons.length + carouselButtonsWithoutParameters.length;
          let quickReplyButtons = this.getEditedButtonParams(totalCarouselButtonsLength);
          
          if (carouselButtons.length > 0 || carouselButtonsWithoutParameters.length > 0 || quickReplyButtons.length > 0) {
            if (!messageParams.BUTTONS) {
              messageParams.BUTTONS = [];
            }
            messageParams.BUTTONS.push(...carouselButtons);
          }
        }
      }
      
      // Build CAROUSEL_HEADERS from carousel card media (overridden or template default)
      if (this.wa_template_subtype === 'Carousel' && this.carousel_message_json?.CAROUSEL?.cards) {
        const carouselHeaders = [];
        const carouselUrlTypes = [];

        this.carousel_message_json.CAROUSEL.cards.forEach((card) => {
          const headerComponent = card.components[0];
          const mediaUrl = headerComponent.overridden_url || headerComponent.image_url || '';
          const mediaType = (headerComponent.format || 'IMAGE').toLowerCase();
          const urlType = headerComponent.overridden_url_type || 'static';

          carouselHeaders.push({ [mediaUrl]: mediaType });
          carouselUrlTypes.push(urlType);
        });

        messageParams.CAROUSEL_HEADERS = carouselHeaders;
        messageParams._carousel_url_types = carouselUrlTypes;
      }

      message_params = messageParams;
      // get custom variable values
      if (this.customInputs?.length) {
        let customVarValues = this.customInputs?.map((e) => { return { key: e.id, value: e.value }; });
        if(customVarValues) {
          custom_messages = customVarValues;
        }
      }
      if(this.$route.fullPath.includes("page-inbox")) return { waTemplateId: this.selectedTemplateId, message_params, custom_messages }
      else return { waTemplateId: this.selectedTemplate.id, message_params, custom_messages }
    },
    getEditedButtonParams(existingButtonsIndex) {
      var arrBtn = [];
      if ( this.quick_replies && this.quick_replies.length ) {
        for ( var i = 0; i < this.quick_replies.length; i++ ) {
          var temp_payload = this.quick_replies[i].payload;
          var tempQR = {
            type: "button",
            sub_type: "quick_reply",
            index: i + existingButtonsIndex,
            parameters: [
              {
                type: "payload",
                payload: temp_payload,
              },
            ],
          };
          arrBtn.push(tempQR);
        }
      }
      return arrBtn;
    },
    getCarouselButtonParams() {
      let carouselButtons = [];
      let buttonIndex = 0;
      
      if (this.carousel_message_json?.CAROUSEL?.cards) {
        this.carousel_message_json.CAROUSEL.cards.forEach((card, cardIndex) => {
          const buttonComponent = card.components?.find(comp => comp.type === 'BUTTONS');
          if (buttonComponent?.buttons) {
            buttonComponent.buttons.forEach((button) => {
              // Only include URL buttons that have dynamic parameters
              if (button.type === 'URL' && button.parameters && button.parameters.length > 0 && button.parameters[0]?.text) {
                carouselButtons.push({
                  type: "button",
                  sub_type: "url",
                  index: buttonIndex,
                  parameters: button.parameters
                });
              }
              buttonIndex++;
            });
          }
        });
      }
      
      return carouselButtons;
    },
    isHeadersEmpty(obj) {
      return Object.keys(obj).length === 0;
    },
    getEditedHeaderParams() {
      const arrTags = [];
      let elementTag = null;

      if (this.header.url) {
        elementTag = this.header.url;
      }
      if (elementTag) {
        const elementObj = {};
        elementObj[elementTag] = this.header.format.toLowerCase();
        arrTags.push(elementObj);
      }
      return arrTags;
    },
    async csv_saveWhatsAppBroadcast(data) {
      const { sendNow, targetingConditions, pageId, segmentId, waTemplateId_A, message_params_A, custom_messages_A, waTemplateId_B, message_params_B, custom_messages_B, distribution_probability, destination_blob_name, failover_messages, uploaded_type, uploaded_type_B, selectSMSSenderID, targeting_count, isNewFileUploaded } = data;
      try {
        let reqBody = {
          name: this.editBroadcast.name,
          mode: sendNow == 'now' ? "send" : sendNow == 'later' ?  "save" : "draft",
          channel: this.editBroadcast.channel,
          pageid: JSON.stringify(pageId),
          template_id: waTemplateId_A,
          targeting_conditions: targetingConditions,
          destination_blob_name: destination_blob_name,
          shopname: this.user.referallshopName,
          url_types: {"HEADER": [uploaded_type]},
          sender_id: selectSMSSenderID === 'custom' ? null : selectSMSSenderID
        };
         // in case edit mode pass broadcast id
        if (this.editBroadcast.id && !this.isDuplicateBroadcast) {
          reqBody.id = this.editBroadcast.id;
        }
        if(isNewFileUploaded){
           reqBody.targeting_count = targeting_count;
        }

        if (segmentId) {
          reqBody.segmentid = segmentId;
        }

        // set params for send later
        if (sendNow == 'later') {
          reqBody.timezone = this.editBroadcast.timezone;
          reqBody.send_date_time =  moment(this.editBroadcast.send_date_time).format('DD/MM/YYYY HH:mm:ss');
        }

        // set button params
        if (message_params_A) {
          reqBody.message_params = message_params_A;
          // Add CAROUSEL_HEADERS to url_types if present
          if (message_params_A._carousel_url_types) {
            reqBody.url_types.CAROUSEL_HEADERS = message_params_A._carousel_url_types;
            delete reqBody.message_params._carousel_url_types;
          }
        }

        // set custom variable values
        if (custom_messages_A) {
          reqBody.custom_messages = custom_messages_A;
        }

        // ------------ start params for version B --------
        if (waTemplateId_B) {
          reqBody.wa_templateids = waTemplateId_B;
          reqBody.distribution_probability = distribution_probability;
          reqBody.url_types_b = {"HEADER": [uploaded_type_B]}; // Only add when A-B testing is on
        }

        if (message_params_B) {
          reqBody.message_paramslisted = message_params_B;
        }

        if (custom_messages_B) {
          reqBody.custom_messagelisted = custom_messages_B;
        }

        //Fallback Message
        if(failover_messages?.length){
          reqBody.failover_messages = failover_messages;
        }
        // ************ start params for version B *********

        const baseUrl = environment("VUE_APP_API_URL");
        const isDraft = sendNow === 'draft';
        const hasId = !!reqBody?.id;

        let url = '';
        let method = 'post';

        if (isDraft && hasId) {
          // Update Draft
          method = 'patch';
          url = `${baseUrl}broadcasts/v1/drafts/${reqBody.id}`;
        } else if (isDraft && !hasId) {
          // Save New Draft
          url = `${baseUrl}broadcasts/v1/drafts`;
        } else {
          // Send Broadcast
          url = `${baseUrl}broadcast-executor/send`;
        }
        const saveBroadcastResponse = await apiInterceptor[method](url, reqBody);
        return saveBroadcastResponse;
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong please try again", type: "danger", });
      }
    },
    async saveBroadcast(data) {
      if (data.destination_blob_name) {
        return await this.csv_saveWhatsAppBroadcast(data);
      } else {
        return await this.saveWhatsAppBroadcast(data);
      }
    },
    async saveWhatsAppBroadcast( data ) {
      const { sendNow, targetingConditions, pageId, segmentId, waTemplateId_A, message_params_A, custom_messages_A, waTemplateId_B, message_params_B, custom_messages_B, distribution_probability, failover_messages, uploaded_type, uploaded_type_B, selectSMSSenderID } = data;
      try {
        let reqBody = {
          name: this.editBroadcast.name,
          mode: sendNow == 'now' ? "send" : sendNow == 'later' ?  "save" : "draft",
          channel: this.editBroadcast.channel,
          pageid: JSON.stringify(pageId),
          template_id: waTemplateId_A,
          targeting_conditions: parseTargetingConditions(targetingConditions, useAuthStore().authData?.userId),
          segmentid: segmentId,
          url_types: {"HEADER": [uploaded_type]},
          sender_id: selectSMSSenderID === 'custom' ? null : selectSMSSenderID
        };
        // in case edit mode pass broadcast id
        if (this.editBroadcast?.id && !this.isDuplicateBroadcast) {
          reqBody.id = this.editBroadcast?.id
        }
        // set params for send later
        if (sendNow == 'later') {
          reqBody.timezone = this.editBroadcast.timezone;
          reqBody.send_date_time = moment(this.editBroadcast.send_date_time).format('DD/MM/YYYY HH:mm:ss');
        }

        // set button params
        // reqBody.message_params = message_params_A || JSON.stringify({'BODY':[]});
        if(message_params_A) {
          reqBody.message_params = message_params_A;
          // Add CAROUSEL_HEADERS to url_types if present
          if (message_params_A._carousel_url_types) {
            reqBody.url_types.CAROUSEL_HEADERS = message_params_A._carousel_url_types;
            delete reqBody.message_params._carousel_url_types;
          }
        }

        // set custom variable values
        if(custom_messages_A) {
          reqBody.custom_messages = custom_messages_A;
        }

        // ------------ start params for version B --------
        if( waTemplateId_B ) {
          reqBody.wa_templateids = waTemplateId_B;
          reqBody.distribution_probability = distribution_probability;
          reqBody.url_types_b = {"HEADER": [uploaded_type_B]}; // Only add when A-B testing is on
          // reqBody.message_paramslisted = message_params_B || JSON.stringify({'BODY':[]});
        }

        if(message_params_B) {
          reqBody.message_paramslisted = message_params_B;
        }

        if(custom_messages_B) {
          reqBody.custom_messagelisted = custom_messages_B;
        }
        
        // Fallback Message
        if(failover_messages?.length){
          reqBody.failover_messages = failover_messages;
        }
        // ************ start params for version B *********


        // set button params
        // if (this.allButtons?.length) {
        //   let messageParams = this.selectedTemplate?.message_params || {};
        //   let buttons = [];
        //   this.allButtons.forEach((button) => {
        //     if (button.static != true) {
        //       buttons.push(
        //         {
        //           "type": "button",
        //           "sub_type": button.sub_type,
        //           "index": button.index,
        //           "parameters": button.parameters
        //         }
        //       )
        //     }
        //   });
        //   messageParams.BUTTONS = buttons;
        //   reqBody.message_params = JSON.stringify(messageParams);
        // }

        // set custom variable values
        // if (this.customInputs?.length) {
        //   let customVarValues = this.customInputs.map((e) => { return { key: e.id, value: e.value }; });
        //   reqBody.custom_messages = JSON.stringify(customVarValues);
        // }
        let saveBroadcastResponse;
        const isDraft = sendNow === 'draft';
        const hasId = !!reqBody?.id;
        const type = isDraft ? 'drafts' : 'broadcasts';
        const method = hasId ? 'patch' : 'post';
        const url = hasId
          ? `${environment("VUE_APP_API_URL")}broadcasts/v1/${type}/${reqBody.id}`
          : `${environment("VUE_APP_API_URL")}broadcasts/v1/${type}`;

        saveBroadcastResponse = await apiInterceptor[method](url, reqBody);
        return saveBroadcastResponse;
      } catch (error) {
        console.error("Exception", error);
        useUIStore().updateToast({ open: true, message: "Something went wrong please try again", type: "danger", });
      }
    },
    handleUrlUpload(urlData) {
      Object.assign(this.header, {
        url: urlData,
        example: urlData
      });
      this.$emit('updatedMedia', { [urlData]: this.header.format });
      this.uploadedFileName = urlData;
      this.isFileUploaded = true;
    },
    async handleFilesUpload (urlData) {
      try {
        this.filesUploading = true;
        this.header.url  = urlData[0]?.url;
        this.header.example = urlData[0].image;
        this.uploadedFileName = urlData[0]?.filename;
        this.isFileUploaded = true;
        const mediaUrl = urlData[0]?.url || urlData[0]?.image;
        if (mediaUrl) {
          this.$emit('updatedMedia', { [mediaUrl]: this.header.format });
        } 
        useUIStore().updateToast({ 
          open: true, 
          message: `${this.header.format.charAt(0).toUpperCase() + this.header.format.slice(1).toLowerCase()} uploaded successfully`, 
          type: "success" 
        });
      } catch (error) {
        console.error("Exception: ", error);
        useUIStore().updateToast({
          open: true,
          message: "Something went wrong",
          type: "danger"
        })
      } finally {
        this.filesUploading = false;
      }
    },
    resetUploadedFiles() {
      // Don't reset header data if we're in duplicate/edit mode and have existing header data
      const shouldPreserveHeader = (this.isDuplicateBroadcast || this.editBroadcast?.id) && 
                                   this.editBroadcast?.wa_message_params?.HEADER && 
                                   Array.isArray(this.editBroadcast.wa_message_params.HEADER) && 
                                   this.editBroadcast.wa_message_params.HEADER.length > 0;
      
      this.isFileUploaded = false;
      this.uploadedFileName = '';
      
      if (!shouldPreserveHeader) {
        this.header.url = '';
        this.header.example = '';
        this.media_url = '';
        this.uploaded_url_type = 'static';
      }
    },
    getIcon(format) {
      switch (format) {
        case 'IMAGE':
          return this.icons.imageOutline;
        case 'VIDEO':
          return this.icons.videocamOutline;
        case 'DOCUMENT':
          return this.icons.documentOutline;
        default:
          break;
      }
    },
    emitCombinedTemplatesLoading() {
      const isLoading = this.templatesLoading || (this.loading && !!this.waTemplateId);
      this.$emit('templatesLoading', !!isLoading);
    },
    getCarouselIcon(button) {
      if (button.action === 'phone' || button.sub_type == 'phone_number') {
        return callOutline;
      } else if (button.action === 'website' || button.sub_type == 'url' || button.type == 'url' || button.type == 'URL') {
        return openOutline;
      } else if (button.type === 'QUICK_REPLY' || button.sub_type == 'quick_reply') {
        return arrowUndoOutline;
      } else {
        return '';
      }
    },
    // Carousel header media override methods
    openCarouselHeaderEditModal(cardIndex) {
      this.carouselHeaderEditIndex = cardIndex;
      this.openCarouselHeaderModal = true;
    },
    closeCarouselHeaderModal() {
      this.openCarouselHeaderModal = false;
      this.carouselHeaderEditIndex = -1;
    },
    onCarouselHeaderMediaUpdated({ cardIndex, mediaUrl, urlType }) {
      if (cardIndex >= 0 && this.carousel_message_json?.CAROUSEL?.cards?.[cardIndex]) {
        const card = this.carousel_message_json.CAROUSEL.cards[cardIndex];
        card.components[0].overridden_url = mediaUrl;
        card.components[0].overridden_url_type = urlType;
        this.$emit('carouselMessageUpdated', this.carousel_message_json);
      }
      this.closeCarouselHeaderModal();
    },
    onCarouselHeaderMediaRemoved({ cardIndex }) {
      if (cardIndex >= 0 && this.carousel_message_json?.CAROUSEL?.cards?.[cardIndex]) {
        const card = this.carousel_message_json.CAROUSEL.cards[cardIndex];
        delete card.components[0].overridden_url;
        delete card.components[0].overridden_url_type;
        this.$emit('carouselMessageUpdated', this.carousel_message_json);
      }
    }
  }
}
</script>

<style>
.dynamic-variable-span {
  background: var(--purple);
  color: var(--white) !important;
  user-select: none;
  border-radius: 10px;
  display: inline-block;
  padding: 0px 5px;
  cursor: pointer;
}

.text-message-wrapper {
  margin-top: 20px;
  display: block;
  padding: 9.5px;
  font-size: 13px;
  line-height: 1.42857143;
  color: #333;
  word-break: break-all;
  word-wrap: break-word;
  background-color: var(--background-primary);
  border: 1px solid var(--gray-04);
  border-radius: 4px;
}

.text-message-wrapper .content {
  white-space: pre-line;
}
.text-message-wrapper .footer {
  color: #9a9a9a;
}

.action-btn-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
}
</style>

<style scoped>
.create-message-wrapper {
  position: relative;
  margin-top: 20px;
}
.noMargin{
  margin-top: 0px;
}
.loading-wrapper {
  height: 80%;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  padding: 20px;
}
.loading-wrapper span{
  font-size: 14px;
  color: var(--black);
}
.rendering-section {
  position: relative;
}
.rendering-section.loading {
  min-height: 50px;
}
.input-files input {
  display: none;
}
.document-selection-wrapper {
  display: flex;
  border: 1px solid;
  border-color: var(--background-primary) !important;
  border-radius: 5px;
}
.document-selection-wrapper .left {
  border-right: 1px solid;
  border-color: var(--background-primary) !important;
}
.document-selection-wrapper .right {
  width: 100%;
}
.custom-variable-input-wrapper {
  margin-top: 30px;
}
.optionsContainer{
  margin-bottom: 20px;
}
.custBorder{
  border-bottom: 1px solid var(--background-primary);
}
.sub-title{
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--gray-04);
}
.modalHeader {
  font-weight: 400;
  font-size: 20px;
  line-height: 16px;
  color: var(--black);
}
.slctContainer {
  width: 100%;
}
.info-box{
  display: flex;
  align-items: center;
  flex-direction: row;
  background: var(--purple-opac);
  padding: 5px 10px;
  border-radius: 5px;
}
.info-text{
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--black);
}
.infoIcon {
  color: var(--purple);
  padding-right: 10px;
  width: 25px;
  height: 25px;
}
.icon{
  padding-right: 5px;
}
.flexContainer{
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.uploadedContainer{
  background: var(--background-primary);
  border-radius: 5px;
  margin: 10px 0px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fileName{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}
.uploadedIcon{
  background: var(--purple);
  border-radius: 5px;
  padding: 5px 8px 3px 8px;
}
.uploadedContainer .title, .documentURL {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.documentURL{
  max-width: 100%;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
}
.singleCarouselCard{
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: flex-start;
  overflow-x: auto;
  margin: 20px 0px 20px 0px;
}
.singleCarouselCard::-webkit-scrollbar {
  display: none;
}
.singleCarouselCard .container{
  min-width: 250px;
  max-width: 300px;
}
.img-block{
	padding: 15px 10px;
  border-radius: 5px 5px 0px 0px;
  background: var(--background-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 140px;
  border: 1px solid var(--gray-04);
}
.carousel-title{
  display: flex;
  align-items: center;
	border: 1px solid var(--gray-04);
  border-top: none;
  border-bottom: none;
  padding: 12px;
}
.carousel-title p {
  max-width: 100%;
}
.carouselImage{
	border-radius: 5px;
  object-fit: cover;
  width: 100%;
  height: 120px;
}
.bttnContainer{
	background: var(--white);
	border: 1px solid var(--purple);
	height: 50px;
	display: flex;
	align-items: center;
  justify-content: center;
}
.bttnContainer:last-child{
	border-radius: 0px 0px 5px 5px;
}
.bttnContainer:not(:last-child) {
  border-bottom: none;
}
.bttnContainer.clickableButton:hover {
  background: var(--purple-opac);
  cursor: pointer;
}
.bttnContainer.disabledContainer {
  opacity: 0.7;
  cursor: not-allowed;
}
.button-text-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
.carouselButtonIcon {
  color: var(--purple);
}
.bttnTitle{
	color: var(--purple);
	font-size: 14px;
	font-weight: 400;
  line-height: 16px;
}
.flexBox{
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.btn-outline-secondary {
  background: transparent;
  border: 1px solid var(--purple);
  color: var(--purple);
  padding: 8px 16px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
}
.btn-outline-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-action-round {
  background: transparent;
  border: 1px solid var(--purple);
  color: var(--purple);
  padding: 6px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 13px;
}
.btn-action-round:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-action-round:hover:not(:disabled) {
  background: var(--purple-opac);
}
.icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
}
.icon-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.dynamic-carousel-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 100px;
}
.dynamic-carousel-placeholder .dynamic-placeholder-icon {
  font-size: 28px;
  color: var(--gray-04);
}
.dynamic-url-label {
  font-size: 12px;
  color: var(--gray-04);
  text-align: center;
}
.img-block {
  position: relative;
}
</style>